module.exports = __webpack_public_path__ + "ce95cb7378e7335b2d20d8b31acac5b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/b_notratable.svg
// module id = 983
// module chunks = 0